import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import Box from "@mui/material/Box";
import CommonAuthHeader from "./CommonAuthHeader";
import Text from "../text/Text";
import {
  getStartedMessage,
  loginGetStartedFooter,
  registerGetStartedFooter,
  signIn,
  signinWithApple,
  signinWithEmail,
  signinWithGoogle,
  signUp,
  SIGN_UP_PAGE,
  LOGIN_PAGE,
  signupWithApple,
  signupWithEmail,
  signupWithGoogle,
  welcomeBack,
} from "../messages";
import Button from "../button/Button";
import { useSession } from "../../hooks/useSession";
import {
  getIsAuthenticated,
  handleSSOLoginRedirection,
  isTMA,
  sourceTelegramApp,
  sourceWebWallet,
} from "../constants";
import { CustomLink } from "../link/Link";

const OptionsGetStarted = ({ isDevice }) => {
  const navigate = useNavigate();
  const { session } = useSession();
  const localhostSsoFe = false;

  const isAuthenticated = getIsAuthenticated(session);
  const [shouldRenderLogin, setShouldRenderLogin] = useState(true);

  const userFirstName = localStorage.getItem("userFirstName");
  const loginWelcomeText = userFirstName
    ? `${welcomeBack}, ${userFirstName}`
    : `${welcomeBack}!`;

  useEffect(() => {
    const url = new URL(window.location.href);
    const referralCode = url.searchParams.get("referral_code");
    if (referralCode) {
      localStorage.setItem("referralCode", referralCode);
      url.searchParams.delete("referral_code");
      window.location.href = url.href;
    }
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <CommonAuthHeader shouldShowBackButton={false}>
      <Box
        display="flex"
        flexDirection="column"
        gap="24px"
        className="get-started"
      >
        <Text
          align="center"
          className="default-text"
          size={28}
          font="bold"
          sx={{
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {shouldRenderLogin ? loginWelcomeText : getStartedMessage}
        </Text>
        {isDevice !== "ios" && (
          <Button
            className="submit-signin-btn social-media-login"
            fullWidth
            variant="default"
            onClick={() => {
              handleSSOLoginRedirection({
                authMethod: "google",
                inviteeAuthState: {
                  from: shouldRenderLogin ? LOGIN_PAGE : SIGN_UP_PAGE,
                },
                localhostSsoFe,
              });
            }}
            label={shouldRenderLogin ? signinWithGoogle : signupWithGoogle}
            iconPosition="start"
            icon="google"
          />
        )}
        {isDevice !== "android" && (
          <Button
            fullWidth
            variant="default"
            className="submit-signin-btn social-media-login"
            onClick={() =>
              handleSSOLoginRedirection({
                authMethod: "apple",
                inviteeAuthState: {
                  source: isTMA() ? sourceTelegramApp : sourceWebWallet,
                  from: shouldRenderLogin ? LOGIN_PAGE : SIGN_UP_PAGE,
                },
                localhostSsoFe,
              })
            }
            label={shouldRenderLogin ? signinWithApple : signupWithApple}
            iconPosition="start"
            icon="apple"
          />
        )}
        <Button
          fullWidth
          className="submit-signin-btn social-media-login"
          variant="default"
          onClick={() =>
            shouldRenderLogin ? navigate("/login") : navigate("/register")
          }
          label={shouldRenderLogin ? signinWithEmail : signupWithEmail}
          icon="emailIcon"
          iconPosition="start"
        />
        <Text
          className="default-text"
          sx={{ m: "0 auto !important" }}
          align="center"
          size={14}
        >
          {shouldRenderLogin ? registerGetStartedFooter : loginGetStartedFooter}{" "}
          <CustomLink
            bold
            onClick={() => setShouldRenderLogin(!shouldRenderLogin)}
            size="small"
            sx={{ textTransform: "uppercase" }}
          >
            {shouldRenderLogin ? signUp : signIn}
          </CustomLink>
        </Text>
      </Box>
    </CommonAuthHeader>
  );
};

export default OptionsGetStarted;
